import { useState, useEffect } from "react";
import "./CorporateTwoPolicyBody.scss";
import { useDocument } from "../../../../../firebase-files/hooks/useDocument";
import RichTextEditor from "react-rte";
import { useAuthContext } from "../../../../../firebase-files/hooks/useAuthContext";
import { projectFirestore } from "../../../../../firebase-config/config";
import { timestamp } from "../../../../../firebase-config/config";
const CorporateTwoPolicyBody = () => {
  const { user } = useAuthContext();
  const { document: pagesTextDataDocument, error: pagesTextDataError } =
    useDocument("pages-data", "privacyPolicy");

  // State to hold the editor value
  const [value, setValue] = useState(RichTextEditor.createEmptyValue());
  const [hasChanges, setHasChanges] = useState(false);

  // Load the data into the editor when the document is fetched
  useEffect(() => {
    if (pagesTextDataDocument) {
      setValue(
        RichTextEditor.createValueFromString(
          pagesTextDataDocument.policyBody,
          "html"
        )
      );
    }
  }, [pagesTextDataDocument]);

  // Function to handle save click
  const handleSaveClick = async () => {
    try {
      const content = value.toString("html");

      const docRef = projectFirestore
        .collection("pages-data")
        .doc("privacyPolicy");
      const docSnap = await docRef.get();

      if (!docSnap.exists) {
        // Create the document if it doesn't exist
        await docRef.set({
          policyBody: content,
          createdAt: timestamp.fromDate(new Date()),
        });
      } else {
        // Update the document if it exists
        await docRef.update({
          policyBody: content,
          updatedAt: timestamp.fromDate(new Date()),
        });
      }

      setHasChanges(false);
    } catch (error) {
      console.error("Error saving policy document:", error);
    }
  };

  // Function to handle changes in the editor
  const handleEditorChange = (newValue) => {
    setValue(newValue);

    const newHtml = newValue.toString("html");
    const existingHtml = pagesTextDataDocument?.policyBody || "";

    if (newHtml !== existingHtml) {
      setHasChanges(true);
    } else {
      setHasChanges(false);
    }
  };

  return (
    <>
      <div className="corporateTwo-policy-body">
        {user && user.role == "admin" && (
          <div>
            <RichTextEditor value={value} onChange={handleEditorChange} />
            {hasChanges && (
              <button
                className="product_edit_save_btn"
                onClick={handleSaveClick}
              >
                Save
              </button>
            )}
          </div>
        )}
      </div>
      <div className="container mb-4">
        <div className="row">
          <p
            dangerouslySetInnerHTML={{
              __html:
                pagesTextDataDocument &&
                pagesTextDataDocument.policyBody.toString("html"),
            }}
          ></p>
        </div>
      </div>
    </>
  );
};

export default CorporateTwoPolicyBody;
